import { useLocation, Link } from "react-router-dom";
import { PublicHeader } from "@/components/layout/PublicHeader";
import { PublicFooter } from "@/components/layout/PublicFooter";
import { Button } from "@/components/ui/button";
import { isNativeIosApp } from "@/lib/platform";

export default function SignUpVerify() {
  const location = useLocation();
  const email = (location.state as any)?.email as string | undefined;
  const isNativeIos = isNativeIosApp();

  return (
    <div className="min-h-screen flex flex-col font-bricolage">
      <PublicHeader />

      <main className="flex-1">
        <section className="pt-24 pb-16 lg:pt-32 lg:pb-24 bg-gradient-hero relative overflow-hidden">
          <div className="absolute inset-0 bg-dotted opacity-50" />
          <div className="container-app relative">
            <div className="max-w-xl mx-auto">
              <div className="bg-card border border-border rounded-2xl shadow-soft p-6 sm:p-8 text-center">
                <h1 className="text-2xl sm:text-3xl font-bold text-foreground">
                  {isNativeIos ? "Organization access only" : "Account created"}
                </h1>
                {isNativeIos ? (
                  <p className="mt-3 text-muted-foreground">
                    Account creation is handled outside the iOS app by your organization administrator.
                    Please sign in with the account provided by your organization.
                  </p>
                ) : (
                  <p className="mt-3 text-muted-foreground">
                    Email confirmation has been sent{email ? (
                      <>
                        {" "}
                        to <span className="font-medium text-foreground">{email}</span>
                      </>
                    ) : (
                      <> to your email</>
                    )}
                    . Please verify to continue.
                  </p>
                )}

                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Button asChild variant="gradient" size="pill-lg">
                    <Link to="/signin">Go to Sign in</Link>
                  </Button>
                  {!isNativeIos && (
                    <Button asChild variant="outline" size="pill-lg">
                      <Link to="/signup">Back</Link>
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <PublicFooter />
    </div>
  );
}


